
export class ConsultaPrecioFacturaDTO{
  aerovale: string;
  matricula: string;
  productoCodigo: string;
  productoNombre: string;
  unidadDeMedida: string;
  cantidad: number;
  tipoOperacion: string;
  rancho: string;
  fechaDespacho: string;
  codigoAeroplantaDespacho: string;
  numeroAeroplantaDespacho: string;
  descripcionAeroplantaDespacho: string;
  ciudadDeDespacho: string;
  codigoDireccionDeEntrega: string;
  ciudadDireccionDeEntrega: string;
  provinciaDireccionDeEntrega: string;
  prefijoRemito: string;
  numeroRemito: string;
  centroEmisorFactura: string;
  numeroFactura: string;
  letraFactura: string;
  fechaFactura: string;
  fechaVencimiento: string;
  codigoAeroplantaFactura: string;
  numeroAeroplantaFactura: string;
  nombreAeroplantaFactura: string;
  codigoMonedaFactura: string;
  descripcionMonedaFactura: string;
  clienteCuenta: string;
  clienteDocumento: string;
  clienteRazonSocial: string;
  lotePrecio: string;
  nivelPrecio: string;
  areaPrecio: string;
  segmentoPrecio: string;
  monedaPrecio: string;
  codigoDireccionDeEntregaPrecio: string;
  fechaDesde: string;
  fechaHasta: string;
  precioFacturado: number;
  precioLista: number;
  tipoBonificacionRecargo: string;
  valorBonificacionRecargo: string;
  valorIva: number;
  valorIIBB: number;
  valorIDC: number;
  valorICL: number;
  comercial: string;
  cuentaSap: string;
  comentarioAerovale: string;
  expendedora: string;
  percepcionIva: string;
  porcentajeBIO: string;
}
